import React from "react";
import LogRocket from "logrocket";

// Top-level safety net: React 18 unmounts the whole tree on any uncaught render
// error (e.g. a null price, an accented name breaking btoa). Without this the booking
// app would blank to a white screen mid-checkout with no recovery and no server trace.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    try {
      LogRocket.captureException(error, {
        extra: { componentStack: info && info.componentStack },
      });
    } catch (e) {}
    try {
      console.error("Booking app render error:", error && error.message);
    } catch (e) {}
  }
  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            maxWidth: 560,
            margin: "60px auto",
            padding: "0 20px",
            textAlign: "center",
            fontFamily: "sans-serif",
          }}
        >
          <h3 style={{ color: "#0d3b5b" }}>Sorry — something went wrong</h3>
          <p style={{ color: "#444", lineHeight: 1.5 }}>
            We hit an unexpected error. Your card has <strong>not</strong> been
            charged unless you have already seen a confirmation page. Please try
            again, or call our bookings team on{" "}
            <a href="tel:08081642780">
              <strong>0808 164 2780</strong>
            </a>{" "}
            and we'll complete your booking for you.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 16,
              padding: "10px 22px",
              border: 0,
              borderRadius: 6,
              background: "#0a7d36",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
